import { EventEmitter } from 'events';

export const RpcEvent = new EventEmitter();
